// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa9f6aad","453":"8ab44547","732":"be0d18e9"}[chunkId] + ".chunk.js";
};